<template>
    <!-- Mis espacios: mismo diseño que Mi cuenta (lateral con título y cifras;
         a la derecha la barra con Agregar espacio, iCalendar y JSON y el
         buscador, y las tarjetas). Sin menú en el lateral: la barra ya lleva
         a todo. Misma API y mismas acciones que la pantalla anterior. -->
    <div class="bk bk--full">
        <aside class="bk-side">
            <h1 class="bk-title">{{ $t('nuevo_menu.sp.title_a') }} <span class="bk-grad">{{ $t('nuevo_menu.sp.title_b') }}</span></h1>
            <p class="bk-subtitle">{{ $t('nuevo_menu.sp.sub') }}</p>
            <div class="bk-stats">
                <div class="bk-stat"><p class="bk-stat-n">{{ resumen.total }}</p><p class="bk-stat-l">{{ $t('nuevo_menu.sp.stat_total') }}</p></div>
                <div class="bk-stat bk-stat--ok"><p class="bk-stat-n">{{ resumen.aprobados }}</p><p class="bk-stat-l">{{ $t('nuevo_menu.sp.stat_ok') }}</p></div>
                <div class="bk-stat bk-stat--wait"><p class="bk-stat-n">{{ resumen.en_revision }}</p><p class="bk-stat-l">{{ $t('nuevo_menu.sp.stat_review') }}</p></div>
            </div>
        </aside>

        <div class="bk-list-main">
            <div class="bk-toolbar">
                <div class="bk-toolbar-actions">
                    <router-link to="/registro-alojamiento" class="bk-btn bk-btn--primary"><span v-html="ICON.plus"></span>{{ $t('nuevo_menu.btn.add_space') }}</router-link>
                    <!-- El usuario "property" no tiene iCalendar (el router lo devuelve acá). -->
                    <router-link v-if="!isProperty" to="/icalendar" class="bk-btn bk-btn--ghost"><span v-html="ICON.sync"></span>{{ $t('nuevo_menu.btn.ical') }}</router-link>
                    <button type="button" :class="['bk-btn', 'bk-btn--ghost', { 'is-on': modoVarios }]" :aria-pressed="String(modoVarios)" @click="alternarVarios">
                        <span v-html="modoVarios ? ICON.close : ICON_VARIOS"></span>{{ modoVarios ? $t('editor_espacio.cancel') : $t('editor_espacio.ms.btn') }}
                    </button>
                </div>
                <label class="bk-search">
                    <span class="bk-sr-only">{{ $t('nuevo_menu.sp.search_label') }}</span>
                    <span v-html="ICON.search"></span>
                    <input v-model="busqueda" type="search" :placeholder="$t('nuevo_menu.sp.search')" autocomplete="off" @input="alBuscar" @keydown.enter.prevent="buscarYa">
                </label>
            </div>

            <!-- Editar varios: barra de selección -->
            <div v-if="modoVarios" class="bk-es-selbar" role="region" :aria-label="$t('editor_espacio.ms.btn')">
                <label class="bk-es-ck"><input type="checkbox" :checked="todasMis || todosEnPantalla" @change="elegirEnPantalla($event.target.checked)"><span>{{ $t('editor_espacio.ms.page_all', { n: idsEnPantalla.length }) }}</span></label>
                <label v-if="resumen.total > idsEnPantalla.length" class="bk-es-ck"><input type="checkbox" :checked="todasMis" @change="elegirTodasMis($event.target.checked)"><span>{{ $t('editor_espacio.ms.all_mine', { n: resumen.total }) }}</span></label>
                <span class="bk-es-n">{{ todasMis ? $t('editor_espacio.ms.all_mine_on', { n: resumen.total }) : elegidosVarios.length ? $tc('editor_espacio.ms.n_chosen_long', elegidosVarios.length, { n: elegidosVarios.length }) : $t('editor_espacio.ms.tap') }}</span>
                <button type="button" class="bk-btn bk-btn--primary" :disabled="!todasMis && !elegidosVarios.length" @click="irAVarios">{{ todasMis ? $tc('editor_espacio.ms.edit_n', resumen.total, { n: resumen.total }) : elegidosVarios.length ? $tc('editor_espacio.ms.edit_n', elegidosVarios.length, { n: elegidosVarios.length }) : $t('editor_espacio.ms.continue') }}</button>
            </div>

            <!-- ── Vista de un edificio: sus unidades ── -->
            <template v-if="selectedProperty">
                <div class="bk-crumb">
                    <button type="button" class="bk-crumb-back" @click="goBack"><span v-html="ICON.back"></span>{{ $t('nuevo_menu.sp.back') }}</button>
                    <h2 class="bk-crumb-name">{{ selectedProperty.nombre || selectedProperty.direccion }}</h2>
                    <span v-if="selectedProperty.categoria" class="bk-badge bk-badge--plain">{{ selectedProperty.categoria }}</span>
                    <router-link :to="{ path: '/host/cargar-unidades', query: { propiedad_id: selectedProperty.idpropiedad } }" class="bk-btn bk-btn--ghost">
                        <span v-html="ICON.plus"></span>{{ $t('nuevo_menu.sp.load_units') }}
                    </router-link>
                </div>
                <p class="bk-sp-addr"><span v-html="ICON.pin"></span>{{ selectedProperty.direccion }} · {{ $tc('nuevo_menu.sp.units', unidadesDe(selectedProperty).length, { n: unidadesDe(selectedProperty).length }) }}</p>

                <div v-if="loadingUnits" class="bk-loading-box"><HyFLoader variant="inline" local /></div>
                <template v-else>
                    <div v-if="pagedUnits(selectedProperty.idpropiedad).length" class="bk-sp-grid">
                        <SpCard
                            v-for="u in pagedUnits(selectedProperty.idpropiedad)"
                            :key="u.idalojamiento"
                            :acc="u"
                            :direccion="selectedProperty.direccion"
                            :estado-tarjeta="estadoTarjeta(u)"
                            @accion="alAccionar"
                            :seleccionable="modoVarios"
                            :elegido="todasMis || elegidosVarios.includes(u.idalojamiento)"
                            @elegir="alternarElegido"
                        />
                    </div>
                    <div v-else class="bk-empty">
                        <div class="bk-empty-ico" aria-hidden="true" v-html="ICON.door"></div>
                        <p class="bk-empty-title">{{ $t('nuevo_menu.sp.no_units') }}</p>
                        <p class="bk-empty-text">{{ $t('nuevo_menu.sp.no_units_text') }}</p>
                        <router-link :to="{ path: '/host/cargar-unidades', query: { propiedad_id: selectedProperty.idpropiedad } }" class="bk-btn bk-btn--primary">{{ $t('nuevo_menu.sp.load_units') }}</router-link>
                    </div>

                    <BkPaginacion
                        :actual="paginaUnidades"
                        :ultima="unitTotalPages(selectedProperty.idpropiedad)"
                        :total="unidadesDe(selectedProperty).length"
                        @ir="p => setUnitPage(selectedProperty.idpropiedad, p)"
                    />
                </template>
            </template>

            <!-- ── Vista principal ── -->
            <template v-else>
                <div class="bk-filters" role="group" :aria-label="$t('nuevo_menu.sp.filter')">
                    <button
                        v-for="f in FILTROS"
                        :key="f"
                        type="button"
                        :class="['bk-filter', { 'is-on': estado === f }]"
                        :aria-pressed="String(estado === f)"
                        @click="filtrar(f)"
                    >{{ $t(`nuevo_menu.sp.f_${f}`) }}</button>
                    <button
                        type="button"
                        :class="['bk-filter', 'bk-filter--more', { 'is-on': panelFiltros || filtrosActivos }]"
                        :aria-expanded="String(panelFiltros)"
                        aria-controls="sp-filtros"
                        @click="panelFiltros = !panelFiltros"
                    >
                        <span v-html="ICON.sliders"></span>{{ $t('nuevo_menu.sp.more_filters') }}<span v-if="filtrosActivos" class="bk-filter-n">{{ filtrosActivos }}</span>
                    </button>
                </div>

                <!-- Filtros: ciudad, tipo, categoría, modalidad y precio (en la moneda elegida arriba) -->
                <transition name="bk-modal-fade">
                    <section v-show="panelFiltros" id="sp-filtros" class="bk-fpanel" :aria-label="$t('nuevo_menu.sp.more_filters')">
                        <div class="bk-fgrid">
                            <label class="bk-fsel">
                                <span class="bk-fsel-k">{{ $t('nuevo_menu.sp.city') }}</span>
                                <select v-model="filtros.ciudad" @change="aplicarFiltros">
                                    <option value="">{{ $t('nuevo_menu.sp.all_f') }}</option>
                                    <option v-for="c in opciones.ciudades" :key="c.valor" :value="c.valor">{{ c.valor }} ({{ c.cantidad }})</option>
                                </select>
                            </label>
                            <label class="bk-fsel">
                                <span class="bk-fsel-k">{{ $t('nuevo_menu.sp.type') }}</span>
                                <select v-model="filtros.tipo" @change="aplicarFiltros">
                                    <option value="">{{ $t('nuevo_menu.sp.all_m') }}</option>
                                    <option v-for="t in opciones.tipos" :key="t.valor" :value="t.valor">{{ nombreTipo(t.valor) }} ({{ t.cantidad }})</option>
                                </select>
                            </label>
                            <label class="bk-fsel">
                                <span class="bk-fsel-k">{{ $t('nuevo_menu.sp.category') }}</span>
                                <select v-model="filtros.categoria" @change="aplicarFiltros">
                                    <option value="">{{ $t('nuevo_menu.sp.all_f') }}</option>
                                    <option v-for="c in opciones.categorias" :key="c.valor" :value="c.valor">{{ nombreCategoria(c.valor) }} ({{ c.cantidad }})</option>
                                </select>
                            </label>
                            <label class="bk-fsel">
                                <span class="bk-fsel-k">{{ $t('nuevo_menu.sp.mode') }}</span>
                                <select v-model="filtros.modalidad" @change="aplicarFiltros">
                                    <option value="">{{ $t('nuevo_menu.sp.all_f') }}</option>
                                    <option value="mensual">{{ $t('nuevo_menu.sp.mode_mensual') }}</option>
                                    <option value="diario">{{ $t('nuevo_menu.sp.mode_diario') }}</option>
                                </select>
                            </label>
                            <div class="bk-fprice" role="group" :aria-label="$t('nuevo_menu.sp.price')">
                                <span class="bk-fsel-k">{{ $t('nuevo_menu.sp.price') }} ({{ moneda }})</span>
                                <div class="bk-fprice-row">
                                    <input v-model="filtros.precioMin" type="number" inputmode="numeric" min="0" :placeholder="$t('nuevo_menu.sp.price_min')" :aria-label="$t('nuevo_menu.sp.price_min')" @input="alCambiarPrecio" @keydown.enter.prevent="aplicarFiltros">
                                    <span aria-hidden="true">–</span>
                                    <input v-model="filtros.precioMax" type="number" inputmode="numeric" min="0" :placeholder="$t('nuevo_menu.sp.price_max')" :aria-label="$t('nuevo_menu.sp.price_max')" @input="alCambiarPrecio" @keydown.enter.prevent="aplicarFiltros">
                                </div>
                            </div>
                        </div>
                        <div class="bk-factions">
                            <p class="bk-fnote">{{ $t('nuevo_menu.sp.price_note', { moneda }) }}</p>
                            <button type="button" class="bk-btn bk-btn--ghost" :disabled="!filtrosActivos" @click="limpiarFiltros">{{ $t('nuevo_menu.sp.clear') }}</button>
                        </div>
                    </section>
                </transition>

                <div v-if="loader" class="bk-loading-box"><HyFLoader variant="inline" /></div>

                <div v-else-if="errorCarga" class="bk-empty" role="alert">
                    <div class="bk-empty-ico" aria-hidden="true" v-html="ICON.home"></div>
                    <p class="bk-empty-title">{{ $t('nuevo_menu.sp.error') }}</p>
                    <p class="bk-empty-text">{{ $t('nuevo_menu.rv.error_text') }}</p>
                    <button type="button" class="bk-btn bk-btn--primary" @click="getAccommodations">{{ $t('nuevo_menu.retry') }}</button>
                </div>

                <template v-else>
                    <!-- Edificios y conjuntos (sin búsqueda ni filtro) -->
                    <template v-if="properties.length && !hayFiltro">
                        <div class="bk-sec-head"><h2 class="bk-sec-title">{{ $t('nuevo_menu.sp.buildings') }}</h2><span class="bk-sec-n">{{ properties.length }}</span></div>
                        <div class="bk-sp-grid">
                            <button
                                v-for="prop in properties"
                                :key="prop.idpropiedad"
                                type="button"
                                class="bk-sp bk-bd"
                                :aria-label="`${prop.nombre || prop.direccion}. ${$tc('nuevo_menu.sp.units', unidadesDe(prop).length, { n: unidadesDe(prop).length })}. ${$t('nuevo_menu.sp.see_units')}`"
                                @click="selectProperty(prop)"
                            >
                                <span class="bk-sp-media">
                                    <img v-if="prop.gallery && prop.gallery.length" class="bk-sp-img" :src="propImageUrl(prop.gallery[0].url)" alt="" loading="lazy">
                                    <span v-else class="bk-sp-noimg" v-html="ICON.building"></span>
                                    <span v-if="prop.categoria" class="bk-sp-tag">{{ prop.categoria }}</span>
                                </span>
                                <span class="bk-sp-body">
                                    <span class="bk-sp-name">{{ prop.nombre || prop.direccion }}</span>
                                    <span class="bk-sp-addr"><span v-html="ICON.pin"></span>{{ prop.direccion }}</span>
                                    <span class="bk-bd-foot">
                                        <span class="bk-bd-units"><span v-html="ICON.door"></span>{{ $tc('nuevo_menu.sp.units', unidadesDe(prop).length, { n: unidadesDe(prop).length }) }}</span>
                                        <span class="bk-bd-go">{{ $t('nuevo_menu.sp.see_units') }} <span v-html="ICON.next"></span></span>
                                    </span>
                                </span>
                            </button>
                        </div>
                    </template>

                    <!-- Alojamientos individuales (o resultados de la búsqueda) -->
                    <template v-if="listaPrincipal.length">
                        <div class="bk-sec-head">
                            <h2 class="bk-sec-title">{{ hayFiltro ? $t('nuevo_menu.sp.results') : $t('nuevo_menu.sp.individual') }}</h2>
                            <span class="bk-sec-n">{{ hayFiltro ? (paginateData.total || listaPrincipal.length) : listaPrincipal.length }}</span>
                        </div>
                        <div class="bk-sp-grid">
                            <SpCard
                                v-for="a in listaPrincipal"
                                :key="a.idalojamiento"
                                :acc="a"
                                :direccion="a.direccion"
                                :estado-tarjeta="estadoTarjeta(a)"
                                @accion="alAccionar"
                                :seleccionable="modoVarios"
                                :elegido="todasMis || elegidosVarios.includes(a.idalojamiento)"
                                @elegir="alternarElegido"
                            />
                        </div>
                    </template>
                    <BkPaginacion
                        v-if="listaPrincipal.length || paginateData.last_page > 1"
                        :actual="paginateData.current_page || 1"
                        :ultima="paginateData.last_page || 1"
                        :total="paginateData.total"
                        @ir="reloadData"
                    />

                    <!-- Vacíos -->
                    <div v-if="!listaPrincipal.length && (hayFiltro || !properties.length)" class="bk-empty">
                        <template v-if="hayFiltro">
                            <div class="bk-empty-ico" aria-hidden="true" v-html="ICON.search"></div>
                            <p class="bk-empty-title">{{ $t('nuevo_menu.sp.not_found') }}</p>
                            <p class="bk-empty-text">{{ $t('nuevo_menu.sp.not_found_text') }}</p>
                            <button type="button" class="bk-btn bk-btn--ghost" @click="limpiarFiltros">{{ $t('nuevo_menu.sp.clear') }}</button>
                        </template>
                        <template v-else>
                            <div class="bk-empty-ico" aria-hidden="true" v-html="ICON.home"></div>
                            <p class="bk-empty-title">{{ $t('nuevo_menu.sp.none') }}</p>
                            <p class="bk-empty-text">{{ $t('nuevo_menu.sp.none_text') }}</p>
                            <router-link to="/registro-alojamiento" class="bk-btn bk-btn--primary"><span v-html="ICON.plus"></span>{{ $t('nuevo_menu.btn.add_space') }}</router-link>
                        </template>
                    </div>
                </template>
            </template>
        </div>

        <!-- ── Confirmar duplicar / eliminar ── -->
        <transition name="bk-modal-fade">
            <div v-if="showConfirmModal" class="bk-modal" @keydown.esc="onConfirmNo">
                <div class="bk-modal-bg" @click="onConfirmNo"></div>
                <div ref="modal" class="bk-modal-card" role="dialog" aria-modal="true" aria-labelledby="sp-modal-t" tabindex="-1">
                    <button type="button" class="bk-modal-x" :aria-label="$t('nuevo_menu.close')" @click="onConfirmNo">×</button>
                    <div :class="['bk-modal-ico', { 'bk-modal-ico--danger': confirmAction === 'delete' }]" aria-hidden="true" v-html="confirmAction === 'delete' ? ICON.trash : ICON.copy"></div>
                    <h2 id="sp-modal-t" class="bk-modal-title">{{ $t(confirmAction === 'delete' ? 'nuevo_menu.sp.del_title' : 'nuevo_menu.sp.dup_title') }}</h2>
                    <p class="bk-modal-text">{{ $t(confirmAction === 'delete' ? 'nuevo_menu.sp.del_text' : 'nuevo_menu.sp.dup_text', { nombre: nombreDe(pendingId) }) }}</p>
                    <div class="bk-modal-acts">
                        <button ref="modalNo" type="button" class="bk-btn bk-btn--ghost" @click="onConfirmNo">{{ $t('nuevo_menu.cancel') }}</button>
                        <button type="button" :class="['bk-btn', confirmAction === 'delete' ? 'bk-btn--danger' : 'bk-btn--primary']" @click="onConfirmYes">
                            {{ $t(confirmAction === 'delete' ? 'nuevo_menu.sp.del_yes' : 'nuevo_menu.sp.dup_yes') }}
                        </button>
                    </div>
                </div>
            </div>
        </transition>

        <!-- ── Compartir ── -->
        <transition name="bk-modal-fade">
            <div v-if="compartir" class="bk-modal" @keydown.esc="compartir = null">
                <div class="bk-modal-bg" @click="compartir = null"></div>
                <div ref="modalShare" class="bk-modal-card" role="dialog" aria-modal="true" aria-labelledby="sp-share-t" tabindex="-1">
                    <button type="button" class="bk-modal-x" :aria-label="$t('nuevo_menu.close')" @click="compartir = null">×</button>
                    <div class="bk-modal-ico" aria-hidden="true" v-html="ICON.share"></div>
                    <h2 id="sp-share-t" class="bk-modal-title">{{ $t('nuevo_menu.sp.share_title') }}</h2>
                    <p class="bk-modal-text">{{ $t('nuevo_menu.sp.share_text') }}</p>
                    <div class="bk-share-url">
                        <code>{{ compartir }}</code>
                        <button ref="copiarBtn" type="button" class="bk-btn bk-btn--primary" @click="copiar(compartir)"><span v-html="ICON.copy"></span>{{ copiado ? $t('nuevo_menu.copied') : $t('nuevo_menu.copy') }}</button>
                    </div>
                    <div class="bk-share-nets">
                        <a class="bk-share-net" :href="`https://wa.me/?text=${encodeURIComponent(compartir)}`" target="_blank" rel="noopener" :aria-label="$t('nuevo_menu.sp.share_wa')" v-html="ICON.wa"></a>
                        <a class="bk-share-net" :href="`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(compartir)}`" target="_blank" rel="noopener" :aria-label="$t('nuevo_menu.sp.share_fb')" v-html="ICON.fb"></a>
                        <a class="bk-share-net" :href="`https://twitter.com/share?url=${encodeURIComponent(compartir)}&via=houseandflatschile`" target="_blank" rel="noopener" :aria-label="$t('nuevo_menu.sp.share_x')" v-html="ICON.x"></a>
                    </div>
                </div>
            </div>
        </transition>

        <!-- Los avisos salen con el cartel de las notificaciones (avisar() en methods). -->
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import axios from "axios";
import { avisar as avisarGlobal } from "@/Utils/notificaciones";
import HyFLoader from "@/components/Loader/HyFLoader.vue";
import SpCard from "@/components/Cuenta/SpCard.vue";
import BkPaginacion from "@/components/Cuenta/BkPaginacion.vue";
import ICON from "@/components/Cuenta/iconos";

const FILTROS = ['todos', 'aprobados', 'pendientes'];
// Filtros del panel ↔ parámetros de la API y de la URL.
const FILTROS_PANEL = { ciudad: 'ciudad', tipo: 'tipo', categoria: 'categoria', modalidad: 'modalidad', precioMin: 'precio_min', precioMax: 'precio_max' };
// Categoría guardada → clave de traducción existente (search.category.*).
const CATEGORIAS = { departamento: 'department', casa: 'house', residencia: 'residency', hostal: 'hostel', hotel: 'hotel', lodge: 'lodge', cabana: 'cabana', refugio: 'albergue', wg: 'wg', camper: 'camper', 'cowork-escritorio': 'cowork.deskflex', reunion: 'cowork.meeting-rooms', cowork: 'cowork.cowork' };
const filtrosVacios = () => ({ ciudad: '', tipo: '', categoria: '', modalidad: '', precioMin: '', precioMax: '' });

export default {
    name: "MisAlojamientos",
    components: { HyFLoader, SpCard, BkPaginacion },

    data() {
        return {
            ICON,
            FILTROS,
            url: (process.env.VUE_APP_SHARE_URL || '').replace(/\/+$/, ''),
            api: process.env.VUE_APP_API_URL,
            loader: true,
            errorCarga: false,
            accommodations: [],
            properties: [],
            propUnits: {},
            propUnitPages: {},
            selectedProperty: null,
            loadingUnits: false,
            unitsPerPage: 6,
            paginateData: {},
            resumen: { total: 0, aprobados: 0, en_revision: 0 },
            // Búsqueda y filtro (van en la URL: ?s=…&estado=…&page=…)
            s: '',
            busqueda: '',
            estado: 'todos',
            pagina: 1,
            buscarTimer: null,
            // Panel de filtros
            panelFiltros: false,
            filtros: filtrosVacios(),
            opciones: { ciudades: [], tipos: [], categorias: [] },
            opcionesCargadas: false,
            precioTimer: null,
            showConfirmModal: false,
            confirmAction: null,
            pendingId: null,
            removingIds: [],
            newlyClonedId: null,
            // Copias hechas en esta visita: id nuevo → id del original (etiqueta "Copia de #…").
            copias: {},
            cloningId: null,
            favoritos: {},
            compartir: null,
            copiado: false,
            aviso: null,
            avisoTimer: null,
            // Editar varios: modo selección de tarjetas
            modoVarios: false,
            elegidosVarios: [],
            // "Todas mis unidades": todas las del usuario, también las de otras
            // páginas y las de los edificios (Editar varios las carga todas).
            todasMis: false,
            ICON_VARIOS: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m12 3 9 5-9 5-9-5z"/><path d="m3 13 9 5 9-5"/></svg>',
        };
    },
    computed: {
        ...mapState(["user"]),
        ...mapState("exchange", ["visitorCurrency"]),
        ...mapGetters(["isProperty"]),
        moneda() {
            return this.visitorCurrency || 'USD';
        },
        filtrosActivos() {
            return Object.values(this.filtros).filter(v => v !== '' && v != null).length;
        },
        hayFiltro() {
            return !!this.s || this.estado !== 'todos' || this.filtrosActivos > 0;
        },
        // Sin búsqueda: los alojamientos sueltos (las unidades se ven dentro de
        // su edificio). Con búsqueda o filtro: todo lo que coincide.
        listaPrincipal() {
            return this.hayFiltro ? this.accommodations : this.accommodations.filter(a => !a.propiedad_idpropiedad);
        },
        paginaUnidades() {
            return (this.selectedProperty && this.propUnitPages[this.selectedProperty.idpropiedad]) || 1;
        },
        // Tarjetas que se ven ahora (para "Todos" del modo Editar varios)
        idsEnPantalla() {
            const l = this.selectedProperty ? this.pagedUnits(this.selectedProperty.idpropiedad) : this.listaPrincipal;
            return l.map(a => a.idalojamiento).filter(id => String(id).indexOf('temp_') !== 0);
        },
        todosEnPantalla() {
            return this.idsEnPantalla.length > 0 && this.idsEnPantalla.every(id => this.elegidosVarios.includes(id));
        },
    },
    watch: {
        // El precio se busca y filtra en la moneda elegida arriba: si cambia, se vuelve a pedir.
        moneda() {
            if (this.filtros.precioMin !== '' || this.filtros.precioMax !== '' || /^[^\dA-Za-zÀ-ÿ]*[\d.,\s]+$/.test(this.s)) this.aplicarFiltros();
        },
        showConfirmModal(val) {
            document.body.style.overflow = val ? 'hidden' : '';
            if (val) this.$nextTick(() => this.$refs.modalNo && this.$refs.modalNo.focus());
        },
        compartir(val) {
            document.body.style.overflow = val ? 'hidden' : '';
            this.copiado = false;
            if (val) this.$nextTick(() => this.$refs.copiarBtn && this.$refs.copiarBtn.focus());
        },
    },
    methods: {
        ...mapActions(["wishList"]),

        // ── Editar varios ──
        alternarVarios() {
            this.modoVarios = !this.modoVarios;
            if (!this.modoVarios) { this.elegidosVarios = []; this.todasMis = false; }
        },
        alternarElegido(id) {
            // Con "Todas mis unidades" marcada, tocar una tarjeta la saca: se
            // pasa a elegir a mano, con los de esta página menos esa.
            if (this.todasMis) {
                this.todasMis = false;
                this.elegidosVarios = this.idsEnPantalla.filter(x => x !== id);
                return;
            }
            this.elegidosVarios = this.elegidosVarios.includes(id) ? this.elegidosVarios.filter(x => x !== id) : [...this.elegidosVarios, id];
        },
        elegirEnPantalla(on) {
            const ids = this.idsEnPantalla;
            if (this.todasMis) {
                this.todasMis = false;
                this.elegidosVarios = on ? [...ids] : [];
                return;
            }
            this.elegidosVarios = on ? [...new Set([...this.elegidosVarios, ...ids])] : this.elegidosVarios.filter(x => !ids.includes(x));
        },
        elegirTodasMis(on) {
            this.todasMis = on;
            if (!on) this.elegidosVarios = [];
        },
        irAVarios() {
            // Todas: no se mandan los ids (pueden ser cientos); Editar varios las elige al cargar.
            const query = this.todasMis ? { todos: '1' } : { ids: this.elegidosVarios.join(',') };
            this.$router.push({ name: 'editar-varios', query });
        },

        // Avisos de la pantalla: mismo cartel que las notificaciones (Utils/notificaciones).
        avisar(tipo, texto, accion = null, cuerpo = '') {
            avisarGlobal({ tipo, titulo: texto, cuerpo, accion: accion ? { label: accion.texto, fn: accion.fn } : null, duracion: accion ? 7000 : null });
        },
        // Lleva la vista a la copia recién creada y la vuelve a resaltar.
        verCopia(id) {
            const el = this.$el.querySelector(`[data-sp="${id}"]`);
            if (!el) return;
            el.scrollIntoView({ behavior: 'smooth', block: 'center' });
            this.newlyClonedId = null;
            this.$nextTick(() => {
                this.newlyClonedId = id;
                clearTimeout(this.resaltarTimer);
                // La copia temporal queda resaltada hasta que llega la real.
                if (String(id).indexOf('temp_') === 0) return;
                this.resaltarTimer = setTimeout(() => { if (this.newlyClonedId === id) this.newlyClonedId = null; }, 4500);
            });
        },

        estadoTarjeta(a) {
            return {
                removing: this.removingIds.includes(a.idalojamiento),
                // La copia temporal tampoco se puede tocar hasta tener su id real.
                cloning: this.cloningId === a.idalojamiento || String(a.idalojamiento).indexOf('temp_') === 0,
                nuevo: this.newlyClonedId === a.idalojamiento,
                copiaDe: this.copias[a.idalojamiento] || null,
                fav: this.favoritos[a.idalojamiento] != null ? this.favoritos[a.idalojamiento] : !!a.alojamiento_idalojamiento,
            };
        },
        alAccionar({ accion, acc }) {
            const id = acc.idalojamiento;
            if (accion === 'fav') {
                const on = !this.estadoTarjeta(acc).fav;
                this.$set(this.favoritos, id, on);
                this.wishList(id);
                return;
            }
            if (accion === 'compartir') { this.compartir = `${this.url}/alojamiento/${id}`; return; }
            if (accion === 'duplicar') return this.handleClonar(id);
            if (accion === 'eliminar') return this.handleEliminar(id);
        },
        nombreDe(id) {
            const todos = [...this.accommodations, ...Object.values(this.propUnits).flat()];
            // eslint-disable-next-line eqeqeq
            const a = todos.find(x => x.idalojamiento == id);
            if (!a) return '';
            try { const j = JSON.parse(a.nombre); return j[this.$i18n.locale] || j.es || Object.values(j)[0] || ''; } catch (e) { return a.nombre || ''; }
        },
        async copiar(texto) {
            try {
                await navigator.clipboard.writeText(texto);
            } catch (e) {
                const ta = document.createElement('textarea');
                ta.value = texto; ta.style.position = 'fixed'; ta.style.opacity = '0';
                document.body.appendChild(ta); ta.select();
                try { document.execCommand('copy'); } catch (e2) { /* sin permiso */ }
                ta.remove();
            }
            this.copiado = true;
        },

        unidadesDe(prop) {
            return this.propUnits[prop.idpropiedad] || prop.units || [];
        },

        propImageUrl(url) {
            if (!url) return '';
            const s3BaseUrl = process.env.VUE_APP_S3_URL || '';
            return this.normalizeS3ImageUrl(url, s3BaseUrl);
        },

        normalizeS3ImageUrl(url, s3BaseUrl) {
            if (!url) return '';

            const bucket = (process.env.VUE_APP_AWS_BUCKET_URL || '').replace(/^\/+|\/+$/g, '');
            if (url.indexOf('http') === -1) {
                return s3BaseUrl + url;
            }

            if (!bucket || url.indexOf('s3-sa-east-1.amazonaws.com') === -1 || url.indexOf(bucket) > -1) {
                return url;
            }

            try {
                const parsedUrl = new URL(url);
                parsedUrl.pathname = `/${bucket}/${parsedUrl.pathname.replace(/^\/+/, '')}`;
                return parsedUrl.toString();
            } catch (e) {
                return url;
            }
        },

        async selectProperty(prop) {
            this.selectedProperty = prop;
            const idpropiedad = prop.idpropiedad;
            if (!this.propUnits[idpropiedad]) {
                this.loadingUnits = true;
                try {
                    const response = await axios.get(`${this.api}properties/${idpropiedad}/units`);
                    this.$set(this.propUnits, idpropiedad, response.data.unidades || []);
                    this.$set(this.propUnitPages, idpropiedad, 1);
                } catch (e) {
                    this.$set(this.propUnits, idpropiedad, []);
                    this.$set(this.propUnitPages, idpropiedad, 1);
                } finally {
                    this.loadingUnits = false;
                }
            }
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },

        goBack() {
            this.selectedProperty = null;
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },

        pagedUnits(idpropiedad) {
            const all = this.propUnits[idpropiedad] || [];
            const page = this.propUnitPages[idpropiedad] || 1;
            const start = (page - 1) * this.unitsPerPage;
            return all.slice(start, start + this.unitsPerPage);
        },

        unitTotalPages(idpropiedad) {
            const all = this.propUnits[idpropiedad] || [];
            return Math.ceil(all.length / this.unitsPerPage);
        },

        setUnitPage(idpropiedad, page) {
            this.$set(this.propUnitPages, idpropiedad, page);
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },

        // ── Lista (misma API: accommodations/get/accommodations) ──
        params() {
            const p = new URLSearchParams();
            if (this.s) p.set('s', this.s);
            if (this.estado !== 'todos') p.set('estado', this.estado);
            Object.entries(FILTROS_PANEL).forEach(([k, param]) => {
                const v = this.filtros[k];
                if (v !== '' && v != null) p.set(param, String(v));
            });
            if (this.pagina > 1) p.set('page', String(this.pagina));
            return p;
        },
        actualizarUrl() {
            const query = Object.fromEntries(this.params());
            this.$router.replace({ query }).catch(() => {});
        },
        async getAccommodations() {
            this.loader = true;
            this.errorCarga = false;
            const pedido = (this._pedido || 0) + 1;
            this._pedido = pedido;
            try {
                // La moneda va siempre: la API la usa para el precio (buscar y filtrar
                // en lo que se ve en la tarjeta). Las opciones de filtros, una vez.
                const p = this.params();
                p.set('moneda', this.moneda);
                if (!this.opcionesCargadas) p.set('opciones', '1');
                const { data } = await axios.get(`${this.api}accommodations/get/accommodations?${p.toString()}`);
                if (pedido !== this._pedido) return;
                this.accommodations = data.data || [];
                this.paginateData = data;
                if (data.resumen) this.resumen = data.resumen;
                if (data.opciones) { this.opciones = data.opciones; this.opcionesCargadas = true; }
            } catch (e) {
                if (pedido !== this._pedido) return;
                console.error('[MisAlojamientos] no se pudieron leer los alojamientos', e);
                this.errorCarga = true;
            } finally {
                if (pedido === this._pedido) this.loader = false;
            }
        },

        nombreTipo(t) {
            const k = `search.types.${t}`;
            return this.$te(k) ? this.$t(k) : t.charAt(0).toUpperCase() + t.slice(1);
        },
        nombreCategoria(c) {
            const k = CATEGORIAS[c] && `search.category.${CATEGORIAS[c]}`;
            return k && this.$te(k) ? this.$t(k) : c.charAt(0).toUpperCase() + c.slice(1).replace(/-/g, ' ');
        },
        aplicarFiltros() {
            clearTimeout(this.precioTimer);
            this.pagina = 1;
            this.selectedProperty = null;
            this.actualizarUrl();
            this.getAccommodations();
        },
        // El precio se aplica al dejar de escribir.
        alCambiarPrecio() {
            clearTimeout(this.precioTimer);
            this.precioTimer = setTimeout(this.aplicarFiltros, 600);
        },

        async getProperties() {
            try {
                const response = await axios.get(`${this.api}properties/my`);
                this.properties = response.data || [];
            } catch (e) {
                this.properties = [];
            }
        },

        reloadData(page) {
            this.pagina = page;
            this.actualizarUrl();
            this.setScrollTop();
            this.getAccommodations();
        },

        // Busca al dejar de escribir (o con Enter).
        alBuscar() {
            clearTimeout(this.buscarTimer);
            this.buscarTimer = setTimeout(this.buscarYa, 450);
        },
        buscarYa() {
            clearTimeout(this.buscarTimer);
            const s = this.busqueda.trim();
            if (s === this.s && !this.selectedProperty) return;
            this.s = s;
            this.pagina = 1;
            this.selectedProperty = null;
            this.actualizarUrl();
            this.getAccommodations();
        },
        filtrar(f) {
            if (this.estado === f) return;
            this.estado = f;
            this.pagina = 1;
            this.actualizarUrl();
            this.getAccommodations();
        },
        limpiarFiltros() {
            clearTimeout(this.precioTimer);
            this.busqueda = '';
            this.s = '';
            this.estado = 'todos';
            this.filtros = filtrosVacios();
            this.pagina = 1;
            this.actualizarUrl();
            this.getAccommodations();
        },

        setScrollTop() {
            window.scrollTo({ top: 0, behavior: "smooth" });
        },

        handleEliminar(id) {
            this.pendingId = id;
            this.confirmAction = 'delete';
            this.showConfirmModal = true;
        },

        handleClonar(id) {
            this.pendingId = id;
            this.confirmAction = 'clone';
            this.showConfirmModal = true;
        },

        onConfirmNo() {
            this.showConfirmModal = false;
            this.pendingId = null;
            this.confirmAction = null;
        },

        async onConfirmYes() {
            this.showConfirmModal = false;
            const id = this.pendingId;
            const action = this.confirmAction;
            this.pendingId = null;
            this.confirmAction = null;
            if (action === 'delete') {
                this.executeDelete(id);
            } else if (action === 'clone') {
                await this.executeClone(id);
            }
        },

        executeDelete(id) {
            this.removingIds = [...this.removingIds, id];
            setTimeout(() => {
                // eslint-disable-next-line eqeqeq
                const borrado = this.accommodations.find(a => a.idalojamiento == id) || Object.values(this.propUnits).flat().find(u => u.idalojamiento == id);
                // eslint-disable-next-line eqeqeq
                this.accommodations = this.accommodations.filter(a => a.idalojamiento != id);
                Object.keys(this.propUnits).forEach(pid => {
                    if (this.propUnits[pid]) {
                        // eslint-disable-next-line eqeqeq
                        this.$set(this.propUnits, pid, this.propUnits[pid].filter(u => u.idalojamiento != id));
                    }
                });
                // eslint-disable-next-line eqeqeq
                this.removingIds = this.removingIds.filter(r => r != id);
                if (borrado) {
                    const ok = borrado.aprobado === 1;
                    this.resumen = {
                        total: Math.max(0, this.resumen.total - 1),
                        aprobados: Math.max(0, this.resumen.aprobados - (ok ? 1 : 0)),
                        en_revision: Math.max(0, this.resumen.en_revision - (ok ? 0 : 1)),
                    };
                }
                axios.delete(`${this.api}accommodations/delete/${id}`, {
                    headers: { "Content-Type": "application/json" }
                }).then(() => this.avisar('ok', this.$t('editor_espacio.nuevo.deleted_t'), null, this.$t('editor_espacio.nuevo.deleted_x', { id })))
                    .catch(() => this.avisar('error', this.$t('nuevo_menu.sp.delete_error')));
            }, 350);
        },

        async executeClone(id) {
            this.cloningId = id;

            // ── Optimistic update: insertar copia temporal de inmediato ──
            const tempId = `temp_${Date.now()}`;
            const source = this.selectedProperty
                // eslint-disable-next-line eqeqeq
                ? (this.propUnits[this.selectedProperty.idpropiedad] || []).find(u => u.idalojamiento == id)
                // eslint-disable-next-line eqeqeq
                : this.accommodations.find(a => a.idalojamiento == id);

            if (source) {
                const optimistic = Object.assign({}, source, { idalojamiento: tempId });
                if (this.selectedProperty) {
                    const pid = this.selectedProperty.idpropiedad;
                    this.$set(this.propUnits, pid, [optimistic, ...(this.propUnits[pid] || [])]);
                } else {
                    this.accommodations = [optimistic, ...this.accommodations];
                }
                this.newlyClonedId = tempId;
                this.$set(this.copias, tempId, id);
                // La copia aparece primera: se lleva la vista hasta ahí.
                this.$nextTick(() => this.verCopia(tempId));
            }

            try {
                const formData = new FormData();
                formData.append('idalojamiento', id);
                await axios.post(`${this.api}accommodations/clone`, formData);
                let nuevoId = null;

                // ── Reemplazar copia temporal con datos reales del servidor ──
                if (this.selectedProperty) {
                    const idpropiedad = this.selectedProperty.idpropiedad;
                    const preIds = new Set(
                        (this.propUnits[idpropiedad] || [])
                            .filter(u => String(u.idalojamiento) !== tempId)
                            .map(u => String(u.idalojamiento))
                    );
                    const response = await axios.get(`${this.api}properties/${idpropiedad}/units`);
                    const newUnits = response.data.unidades || [];
                    const newReal = newUnits.find(u => !preIds.has(String(u.idalojamiento)));
                    if (newReal) {
                        const current = this.propUnits[idpropiedad] || [];
                        this.$set(this.propUnits, idpropiedad,
                            current.map(u => String(u.idalojamiento) === tempId ? newReal : u)
                        );
                        nuevoId = newReal.idalojamiento;
                    } else {
                        this.$set(this.propUnits, idpropiedad, newUnits);
                    }
                } else {
                    const preIds = new Set(
                        this.accommodations
                            .filter(a => String(a.idalojamiento) !== tempId)
                            .map(a => String(a.idalojamiento))
                    );
                    // Siempre pedir página 1 (orden DESC: el clon nuevo queda primero)
                    const p = this.params();
                    p.delete('page');
                    p.set('moneda', this.moneda);
                    const response = await axios.get(`${this.api}accommodations/get/accommodations?${p.toString()}`);
                    const freshData = (response.data && response.data.data) ? response.data.data : [];
                    const newReal = freshData.find(a => !preIds.has(String(a.idalojamiento)));
                    if (response.data && response.data.resumen) this.resumen = response.data.resumen;
                    if (newReal) {
                        this.accommodations = this.accommodations
                            .map(a => String(a.idalojamiento) === tempId ? newReal : a);
                        this.paginateData = response.data;
                        nuevoId = newReal.idalojamiento;
                    } else {
                        this.accommodations = freshData;
                        this.paginateData = response.data;
                    }
                }
                this.$delete(this.copias, tempId);
                if (nuevoId != null) {
                    this.$set(this.copias, nuevoId, id);
                    this.$nextTick(() => this.verCopia(nuevoId));
                    this.avisar('ok', this.$t('nuevo_menu.sp.duplicated_from', { id }), { texto: this.$t('nuevo_menu.sp.see_copy'), fn: () => this.verCopia(nuevoId) });
                } else {
                    this.newlyClonedId = null;
                    this.avisar('ok', this.$t('nuevo_menu.sp.duplicated'));
                }
            } catch (e) {
                // Revertir optimistic update en caso de error
                if (this.selectedProperty) {
                    const pid = this.selectedProperty.idpropiedad;
                    this.$set(this.propUnits, pid,
                        (this.propUnits[pid] || []).filter(u => String(u.idalojamiento) !== tempId)
                    );
                } else {
                    this.accommodations = this.accommodations.filter(a => String(a.idalojamiento) !== tempId);
                }
                this.newlyClonedId = null;
                this.$delete(this.copias, tempId);
                this.avisar('error', this.$t('nuevo_menu.sp.duplicate_error'));
            } finally {
                this.cloningId = null;
            }
        },
    },
    created() {
        const q = this.$route.query;
        this.s = typeof q.s === 'string' ? q.s : '';
        this.busqueda = this.s;
        this.estado = FILTROS.includes(q.estado) ? q.estado : 'todos';
        Object.entries(FILTROS_PANEL).forEach(([k, param]) => {
            if (typeof q[param] === 'string') this.filtros[k] = q[param];
        });
        this.panelFiltros = this.filtrosActivos > 0;
        this.pagina = Number(q.page) > 0 ? Number(q.page) : 1;
        this.getAccommodations();
        this.getProperties();
        window.scrollTo(0, 0);
        // "Deshacer" de Editar varios desde el aviso: se recarga la lista.
        this.alCambiarEspacios = () => this.getAccommodations();
        window.addEventListener('hyf:espacios-cambiaron', this.alCambiarEspacios);
    },
    beforeDestroy() {
        window.removeEventListener('hyf:espacios-cambiaron', this.alCambiarEspacios);
        clearTimeout(this.buscarTimer);
        clearTimeout(this.precioTimer);
        clearTimeout(this.avisoTimer);
        clearTimeout(this.resaltarTimer);
        document.body.style.overflow = '';
    },
};
</script>

<style src="../../components/BankInformation/bkCuenta.css"></style>
<style src="../../components/Cuenta/cuentaMenu.css"></style>
<style>
/* Íconos dentro de botones y textos: sin caja propia. */
.bk-toolbar .bk-btn > span, .bk-search > span:not(.bk-sr-only), .bk-crumb-back > span, .bk-crumb .bk-btn > span,
.bk-sp-addr > span, .bk-bd-units > span, .bk-bd-go > span, .bk-empty .bk-btn > span, .bk-share-url .bk-btn > span { display: contents; }
/* Editar varios: botón activo y barra de selección (diseño de la demo) */
.bk-toolbar .bk-btn.is-on { border-color: var(--bk-orange); color: var(--bk-orange-dark); }
.bk-es-selbar { position: sticky; top: calc(var(--bk-top) - 20px); z-index: 6; display: flex; align-items: center; gap: 14px; margin-top: 14px; padding: 10px 10px 10px 18px; border-radius: 18px; background: rgba(255, 255, 255, .95); -webkit-backdrop-filter: blur(14px); backdrop-filter: blur(14px); border: 1px solid rgba(232, 100, 10, .25); box-shadow: 0 18px 40px -20px rgba(122, 57, 0, .45); animation: bk-rise .3s var(--bk-ease) both; }
.bk-es-ck { display: flex; align-items: center; gap: 10px; margin: 0; font-size: 14.5px; font-weight: 600; white-space: nowrap; cursor: pointer; }
.bk-es-ck input { width: 20px; height: 20px; margin: 0; accent-color: var(--bk-orange); cursor: pointer; }
.bk-es-n { flex: 1; font-size: 14px; color: var(--bk-muted); }
@media (max-width: 640px) {
    .bk-es-selbar { flex-wrap: wrap; padding: 10px 12px; }
    .bk-es-n { order: 3; flex-basis: 100%; }
    .bk-es-selbar .bk-btn { margin-left: auto; }
}
</style>
